export const getOrgUserCoursesApiHandler = {
  method: "GET",
  path: (payload: { userId: string | number }) => `org-users-management/${payload.userId}/courses`,
  params: {} as {'skip'?: string | number, 'take'?: string | number}
};